import { getHttpService } from './HttpService';
import { error } from '@/utils/error';
import { CLIENT_CONTROLLER, PROPOSITIONS } from '@/constants';

//old
interface HospitalResponse {
    data: HospitalData;
}

interface HospitalData {
    lat: number;
    lng: number;
    zorginstellingen: HealthcareInstitutions[];
    isSucces: boolean;
    errorCode?: null;
    statusCode: number;
    loginAlsKlantSessieNotActive: boolean;
    content?: null;
}

interface HealthcareInstitutions {
    agbNummer: string;
    naam: string;
    contractStatus: string;
    vestigingen: Branches[];
}
//deze wordt ook in de nieuwe gebruikt
interface Branches {
    afstand: number;
    lat: number;
    lng: number;
    plaats: string;
    detailUrl: string;
    naam: string;
    id: string;
    relativeUrl: string;
}

interface Args {
    postal: string;
    insurance: string;
    brand: string;
}
//end old
interface HospitalContractResponse {
    data: HospitalContractData;
}

interface HospitalContractData {
    latitude: number;
    longitude: number;
    ziekenhuizen: Contracts[];
    isSucces: boolean;
    errorCode?: null;
    statusCode: number;
    loginAlsKlantSessieNotActive: boolean;
    content?: null;
}

interface Contracts {
    agbNummer: string;
    naam: string;
    contractStatus: string;
    contractOmschrijving: string;
    contractToelichting: string;
    contractUitklapTekst: string;
    typeContractVergoeding: string;
    plafondafspraak: boolean;
    vestigingen: Branches[];
}

interface SearchArgs {
    postal: string;
    insurance: number;
    brand: string;
}

const HttpService = getHttpService();

const getHospitals = async ({ postal, insurance, brand }: Args): Promise<HospitalData> => {
    const path = '/clientcontroller/salesfunnelclient/ophalenziekenhuizen';
    const payload = {
        Locatie: postal,
        Pakket: insurance,
        Propositie: brand ?? PROPOSITIONS.ZK
    };
    const { data } = (await HttpService.post(path, payload)) as HospitalResponse;

    if (data.isSucces === false) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path,
            payload: JSON.stringify(payload)
        });
    }

    return data;
};

const getHospitalContracts = async ({
    postal,
    insurance,
    brand
}: SearchArgs): Promise<HospitalContractData> => {
    const path = '/clientcontroller/salesfunnelclient/gethospitals';
    const payload = {
        Locatie: postal,
        PolissoortNummer: insurance,
        Propositie: brand ?? PROPOSITIONS.ZK
    };
    const { data } = (await HttpService.post(path, payload)) as HospitalContractResponse;

    if (data.isSucces === false) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path,
            payload: JSON.stringify(payload)
        });
    }

    return data;
};

export default {
    getHospitals,
    getHospitalContracts
};
